import React, { useCallback, useState } from 'react';
import { useT } from '@transifex/react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import { getDistributor } from '@raisin/cp-utils';
import { SingleSelect } from '@raisin/components-lib';
import { sortingOptions } from 'types';
import messages from '../../../messages';
import { handleBankListSort } from 'eventsTracking/BankList/onListOfBanksSorted';
import { BANK_EVENTS } from 'eventsTracking';
import * as S from './styles';

export const Sort = ({ sortBy, onChange }) => {
  const t = useT();
  const distributorId = getDistributor();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.between('xs', 'lg'));

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = useCallback(
    (sortOption) => {
      onChange(sortOption);
      handleBankListSort({
        sortingCriteria: sortOption,
        distributorId,
        eventName: BANK_EVENTS.LIST_OF_BANKS_SORTED,
      });
      handleMenuClose();
    },
    [onChange],
  );

  return isMobile ? (
    <S.FilterContainer container>
      <Grid item>
        <S.ButtonWithIcon aria-label="sort" onClick={handleMenuOpen}>
          <S.SortIcon src="/cp_assets/sort.svg" />
        </S.ButtonWithIcon>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <MenuItem onClick={() => handleMenuClick(sortingOptions.BANK_NAME)}>
            {t(messages.bankListSortAlphabetically)}
          </MenuItem>
          <MenuItem onClick={() => handleMenuClick(sortingOptions.RATING)}>
            {t(messages.bankListSortByRating)}
          </MenuItem>
        </Menu>
      </Grid>
    </S.FilterContainer>
  ) : (
    <S.FormContainer sx={{ m: 2, minWidth: 120 }} size="small">
      <S.SortLabel variant="h5">{t(messages.bankListSortByLabel)}:</S.SortLabel>

      <SingleSelect
        width={320}
        value={sortBy}
        onChange={(value) => {
          onChange(value);
          handleBankListSort({
            sortingCriteria: value as string,
            distributorId,
            eventName: BANK_EVENTS.LIST_OF_BANKS_SORTED,
          });
        }}
        options={[
          {
            text: t(messages.bankListSortAlphabetically),
            value: sortingOptions.BANK_NAME,
          },
          {
            text: t(messages.bankListSortByRating),
            value: sortingOptions.RATING,
          },
        ]}
        testId="sort-select"
      />
    </S.FormContainer>
  );
};
